import { useContext } from 'react';
import { VehicleContext } from '../context/VehicleContext';
export function useVehicles() { return useContext(VehicleContext); }